export function decimalToDms(decimal) {
    const abs = Math.abs(decimal);
    const degrees = Math.floor(abs);
    const minutesDecimal = (abs - degrees) * 60;
    const minutes = Math.floor(minutesDecimal);
    const seconds = (minutesDecimal - minutes) * 60;
    return { degrees, minutes, seconds };
}

export function getLatitudeDirection(latitude) {
    return latitude >= 0 ? 'N' : 'S';
}

export function getLongitudeDirection(longitude) {
    return longitude >= 0 ? 'E' : 'W';
}
